import React, { useEffect, useRef, useState } from 'react'
import { SerializedStyles, css } from '@emotion/core'
import parse from 'html-react-parser'

interface ComponentProps extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  resize?: 'both' | 'horizontal' | 'vertical'
  customCss?: SerializedStyles
}

export const LinkPreviewTextarea: React.FC<ComponentProps> = props => {
  const [isFocus, setIsFocus] = useState(false)
  const textareaREf = useRef<HTMLTextAreaElement>(null)

  const convertTextToHtml = (text: string) => {
    const urlRegex = /(https?:\/\/.+?)(?=\s|&quot;|$)/g
    return text
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(urlRegex, url => `<a href="${url}" target="_blank">${url}</a>`)
      .replace(/\n/g, '<br>')
  }

  useEffect(() => {
    if (isFocus) {
      textareaREf.current?.focus()
      textareaREf.current?.click()
    }
  }, [isFocus])

  return (
    <div css={[baseStyle, props.customCss]} style={props.resize ? { resize: props.resize, overflow: 'hidden' } : undefined}>
      <textarea
        name="link-preview-textarea"
        {...props}
        ref={textareaREf}
        onBlur={() => {
          setIsFocus(false)
        }}
        style={{ display: isFocus ? 'block' : 'none' }}
      />
      <div
        onClick={e => {
          if ((e.target as any).tagName === 'A') {
            return
          }
          setIsFocus(true)
        }}
        style={{
          display: !isFocus ? 'block' : 'none',
          color: !props.value && props.placeholder ? '#cccccc' : 'inherit',
        }}
      >
        {props.value ? parse(convertTextToHtml(`${props.value}`)) : props.placeholder}
      </div>
    </div>
  )
}

const baseStyle = css({
  width: '100%',
  overflow: 'hidden',
  'textarea, > div': {
    width: '100%',
    height: '100%',
    border: '1px solid #CCCCCC',
    borderRadius: 10,
    padding: 12,
    a: { color: '#f2a40b' },
  },
  textarea: {
    resize: 'none',
    '&::placeholder': { color: '#CCCCCC' },
  },
  '> div': {
    overflowX: 'hidden',
    overflowY: 'auto',
  },
})
